import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class PurchaseLogService extends Service {
	constructor(injector: Injector) {
		super("PurchaseLog", injector);
	}

	// API
	app_Complete(id:number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_Complete/${id}`,{});
	}
	app_CompleteMissing(id:number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_CompleteMissing/${id}`,{});
	}
	app_GetById(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_GetById/${id}`);
	}

	app_GetDue() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_GetDue/`);
	}

	dueBySupplierAndDateRange(supplierId: number, dateFrom: Date, dateTo: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/DueBySupplierAndDateRange/${supplierId}/${dateFrom.toDateString()}/${dateTo.toDateString()}`);
	}

	duplicatePurchaseLog(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Duplicate/${id}`, {});
	}

	generateAndEmailPdf(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GenerateAndEmailPdf/${id}`);
	}

	generateAndPreviewPdf(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GenerateAndPreviewPdf/${id}`, { responseType: "blob" as "json"} );
	}
	
	getByContractId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForContract/${id}`);
	}
	
	getByProjectId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByProjectId/${id}`);
	}

	getTotalSpend(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetTotalSpend/${id}`);
	}

	goodsInDashboard() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GoodsInDashboard`);
	}

	markPaid(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/MarkPaid/${id}`, {});
	}

	paidBySupplierWithinDateRange(supplierId: number, dateFrom: Date, dateTo: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PaidBySupplierWithinDateRange/${supplierId}/${dateFrom.toDateString()}/${dateTo.toDateString()}`);
	}

	paidWithinDateRange(dateFrom: Date, dateTo: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PaidWithinDateRange/${dateFrom.toDateString()}/${dateTo.toDateString()}`);
	}

	paymentDueBySupplierWithinDateRange(supplierId: number, dateFrom: Date, dateTo: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PaymentDueBySupplierWithinDateRange/${supplierId}/${dateFrom.toDateString()}/${dateTo.toDateString()}`);
	}

	paymentDueWithinDateRange(dateFrom: Date, dateTo: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PaymentDueWithinDateRange/${dateFrom.toDateString()}/${dateTo.toDateString()}`);
	}

	paymentOverdue() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PaymentOverdue`);
	}

	paymentOverdueBySupplier(supplierId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PaymentOverdueBySupplier/${supplierId}`);
	}

	spendSummaryBySupplier(supplierId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/SpendSummaryBySupplier/${supplierId}`);
	}

	totalPaidBySupplierWithinDateRange(supplierId: number, dateFrom: Date, dateTo: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/TotalPaidBySupplierWithinDateRange/${supplierId}/${dateFrom.toDateString()}/${dateTo.toDateString()}`);
	}

	totalPaymentDueBySupplierWithinDateRange(supplierId: number, dateFrom: Date, dateTo: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/TotalPaymentDueBySupplierWithinDateRange/${supplierId}/${dateFrom.toDateString()}/${dateTo.toDateString()}`);
	}

	totalPaymentOverdueBySupplier(supplierId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/TotalPaymentOverdueBySupplier/${supplierId}`);
	}
}